/**
 * @file AccessDenied.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-05-12
 * @modified 2026-05-12
 *
 * Defense-in-depth banner for screens gated by a permission the current user
 * doesn't hold. Menu items are already hidden for unauthorised users in
 * Dashboard.js; this is the safety net for direct URL navigation, browser
 * back/forward, and the case where a permission is revoked while a tab is
 * open.
 *
 *   import AccessDenied from './AccessDenied';
 *   if (!hasPermission(user, 'foo')) {
 *     return <AccessDenied permission="Foo" />;
 *   }
 */

import React from 'react';

function AccessDenied({ permission }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        textAlign: 'center',
        gap: '12px',
        color: 'var(--text-primary, #333)'
      }}
    >
      <span
        className="material-symbols-rounded"
        style={{ fontSize: '64px', color: 'var(--color-warning, #f59e0b)' }}
      >
        lock
      </span>
      <h2 style={{ margin: 0 }}>Access denied</h2>
      <p style={{ maxWidth: '420px', margin: 0, color: 'var(--text-secondary, #666)' }}>
        You don't have permission to access this screen.
        {permission && (
          <>
            {' '}Ask an admin to grant you the <strong>{permission}</strong> permission in User Management.
          </>
        )}
      </p>
    </div>
  );
}

export default AccessDenied;
